import React from 'react';
import question from 'assets/question-bubble.png';
import { useStateBus } from '~/state/bridge';
import { getTargetingVisible } from '~/state/Targeting/selectors';

import Helpbox from './Helpbox';

const renderPeople = (number, targetingVisible) => {
  if (targetingVisible) {
    return number > 0
      ? <p>{`${number.toLocaleString('en')} people`}</p>
      : <p>{'< 1000 people'}</p>;
  }

  return <p>---</p>;
};

const Reach = (props) => {
  const {
    title,
    helpboxText,
    numberPeople,
  } = props;

  const targetingVisible = useStateBus(getTargetingVisible);

  return (
    <div className="collage__header">
      <div className="row centered">
        <h4>{title}</h4>
        <Helpbox icon={question}>
          { helpboxText }
        </Helpbox>
      </div>
      { renderPeople(numberPeople, targetingVisible) }
    </div>
  );
};

export default Reach;
